import * as React from 'react';
import { useLocation } from 'react-router-dom';

import '../../styles/components/FormIsNotAvailable.css'
import { pageNotFoundTitle, pageNotFoundMessage } from '../../constants/Constants';

const PageNotFound = () => {
        const location = useLocation();
        const { title, message } = location.state || {}
        return (
                <div className="form-isnt-available">
                        <div className="logo-wrapper">
                                <img className="vector" alt="ARI Recruiting" src={require('../../images/vector.png')} />
                                <img className="logo" alt="ARI Recruiting" src={require('../../images/ari_logo.png')} />
                        </div>
                        <div className="content">
                                <h1>{title || pageNotFoundTitle}</h1>
                                <p>{message || pageNotFoundMessage}</p>
                        </div>
                </div>
        )
}

export default PageNotFound